export default "__VITE_ASSET__CCWEoe5a__"